<template>
  <v-app>
    <v-app-bar
      elevation="1"
      class="top-bot"
      color="white"
      style="border-bottom: 1px solid #f0f0f0"
    >
      <v-container fluid>
        <div
          class="d-flex align-center justify-space-between flex-wrap"
          style="color: #e93175"
        >
          <div class="d-flex align-center">
            <v-icon size="28" class="mr-2">mdi-school</v-icon>

            <span
              class="font-weight-bold"
              :class="!isSmAndUp ? 'text-subtitle-1' : 'text-h6'"
            >
              Southern Davao National High School
            </span>
          </div>

          <div
            v-if="isSmAndUp"
            class="text-caption font-weight-medium text-right mt-1 mt-sm-0"
          >
            facebook • twitter • email • number
          </div>
        </div>
      </v-container>
    </v-app-bar>
    <!-- HERO SECTION -->
    <v-container fluid class="hero-section py-16 mt-15">
      <v-row align="center" justify="center">
        <v-col cols="12" md="7" class="text-center">
          <v-img
            src="/img/landingpage.jpg"
            max-width="780"
            class="mx-auto"
            cover
            rounded="xl"
          />
        </v-col>
        <v-col cols="12" md="5" class="d-flex justify-center align-center">
          <div>
            <p
              class="text-pink school-code-light"
              :style="
                isSmAndUp
                  ? { fontSize: '42px', fontWeight: '800' }
                  : {
                      fontSize: '20px',
                      fontWeight: '1000',
                      textAlign: 'center',
                    }
              "
            >
              SOUTHERN DAVAO NATIONAL HIGH SCHOOL
            </p>

            <p class="hero-subtitle mt-4">
              "Education is the most powerful weapon which you can use to change
              the world." <br />— Nelson Mandela
            </p>

            <v-btn
              color="pink"
              size="large"
              rounded="xl"
              elevation="2"
              class="mt-6 mx-2 px-8"
              :block="!isSmAndUp"
              @click="goToDiv()"
            >
              Open Portal
            </v-btn>

            <!-- <v-btn
              color="pink"
              variant="outlined"
              size="large"
              rounded="xl"
              class="mt-6 mx-2 px-8"
              @click="goToEvents()"
            >
              View Events
            </v-btn> -->
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-divider color="black"></v-divider>
    <!--EVENTS-->
    <div style="background-color: #f3f3f3; width: 100%" id="events">
      <v-container class="py-12">
        <v-row>
          <v-col
            cols="12"
            v-for="(events, eventType) in eventList.event"
            :key="eventType"
            class="mb-10"
          >
            <div class="d-flex align-center mb-6">
              <v-icon size="32" class="mr-3" color="pink">
                {{ getIcon(eventType) }}
              </v-icon>

              <h2
                class="font-weight-bold"
                style="color: #e93175; text-transform: uppercase"
              >
                {{ eventType }}
              </h2>

              <v-spacer />

              <v-chip color="pink" variant="tonal" size="small">
                {{ events.length }} events
              </v-chip>
            </div>

            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
                v-for="(event, i) in events"
                :key="i"
              >
                <v-card rounded="xl" elevation="2" class="event-card">
                  <v-card-text>
                    <div class="event-image-wrapper">
                      <v-img
                        :src="
                          event.eventFile
                            ? event.eventFile
                            : '/img/returnImg.jpg'
                        "
                        height="200"
                        cover
                      />
                    </div>
                    <v-chip
                      color="pink"
                      variant="outlined"
                      size="small"
                      class="my-3"
                    >
                      {{ formatDate(event.eventDate) }}
                    </v-chip>

                    <h3 class="mb-2 font-weight-medium">
                      {{ event.eventName }}
                    </h3>
                  </v-card-text>

                  <v-divider />

                  <v-card-actions>
                    <v-btn
                      variant="text"
                      color="pink"
                      size="small"
                      @click="Event(event)"
                    >
                      View Details
                    </v-btn>

                    <v-spacer />

                    <v-icon size="18" color="grey"> mdi-calendar </v-icon>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- FOOTER -->
    <v-divider color="black"></v-divider>
    <v-footer class="pa-14">
      <v-row>
        <v-col
          cols="12"
          md="4"
          class="px-12"
          style="border: 1px solid pink; border-radius: 10px"
        >
          <div class="text-center">
            <strong>MISSION</strong>
          </div>
          <div class="text-justify">
            <p class="text-grey mt-2">
              To protect and promote the right of every Filipino to quality,
              equitable, culture-based, and complete basic education where:
              Students learn in a child-friendly, gender-sensitive, safe, and
              motivating environment. Teachers facilitate learning and
              constantly nurture every learner. Administrators and staff, as
              stewards of the institution, ensure an enabling and supportive
              environment for effective learning to happen. Family, community,
              and other stakeholders are actively engaged and share
              responsibility for developing life-long learners.
            </p>
          </div>
        </v-col>
        <v-col
          cols="12"
          md="4"
          class="px-12"
          style="border: 1px solid pink; border-radius: 10px"
        >
          <div class="text-center">
            <strong>CORE VALUES</strong>
          </div>

          <div class="text-center">
            <p class="text-grey mt-2">
              Maka-Diyos <br />
              Maka-tao <br />Makakalikasan <br />
              Makabansa
            </p>
          </div>
        </v-col>
        <v-col
          cols="12"
          md="4"
          class="px-12"
          style="border: 1px solid pink; border-radius: 10px"
        >
          <div class="text-center">
            <strong>VISION</strong>
          </div>
          <div class="text-justify">
            <p class="text-grey">
              We dream of Filipinos who passionately love their country and
              whose values and competencies enable them to realize their full
              potential and contribute meaningfully to building the nation. As a
              learner-centered public institution, the Department of Education
              continuously improves itself to better serve its stakeholders.
            </p>
          </div>
        </v-col>
      </v-row>
    </v-footer>

    <v-dialog
      v-if="portalDialog"
      v-model="portalDialog"
      max-width="760"
      :fullscreen="!isSmAndUp"
    >
      <v-card :rounded="isSmAndUp ? 'xl' : ''" class="portal-dialog">
        <v-card-title class="text-center py-6">
          <div class="text-h6 font-weight-bold">Choose your portal</div>
          <div class="text-body-2 text-medium-emphasis mt-1">
            Select the portal that applies to you to sign in
          </div>
        </v-card-title>

        <v-divider />

        <v-card-text class="py-8">
          <v-row justify="center" dense>
            <v-col
              v-for="(item, i) in modules"
              :key="i"
              cols="12"
              sm="6"
              class="d-flex justify-center"
            >
              <v-card
                @click="setActive(i)"
                rounded="xl"
                height="290"
                width="310"
                :elevation="item.active ? 12 : 4"
                :class="[
                  'module-card d-flex flex-column align-center justify-center pa-6 mb-2',
                  item.active ? 'active-card' : 'inactive-card',
                ]"
              >
                <!-- <v-icon
                  size="68"
                  class="mb-4"
                  :color="item.active ? 'white' : 'pink'"
                >
                  {{ item.icon }}
                </v-icon> -->
                <v-img
                  :src="item.image"
                  height="160"
                  width="100%"
                  cover
                  class="mb-1 pa-2"
                />

                <div
                  class="text-subtitle-1 font-weight-medium text-center"
                  :class="item.active ? 'text-white' : 'text-grey-darken-4'"
                >
                  {{ item.label }}
                </div>

                <v-chip
                  v-if="item.active"
                  size="x-small"
                  color="white"
                  variant="outlined"
                  class="mt-3"
                >
                  Selected
                </v-chip>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider />

        <v-card-actions class="px-6 py-4">
          <v-spacer />
          <v-btn variant="flat" color="red" @click="portalDialog = false">
            Cancel
          </v-btn>

          <!-- <v-btn
            color="primary"
            variant="flat"
            class="ml-3"
            :disabled="!modules.some((m) => m.active)"
          >
            Continue
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="viewDetailDialog"
      max-width="760"
      :fullscreen="!isSmAndUp"
    >
      <v-card :rounded="isSmAndUp ? 'xl' : '0'" class="portal-dialog">
        <!-- HEADER -->
        <v-card-title class="d-flex align-center px-6 py-4">
          <v-icon color="pink" size="28" class="mr-3">
            mdi-calendar-star
          </v-icon>

          <div>
            <div class="dialog-title">Event Details</div>
            <div class="dialog-subtitle">
              Complete information about this event
            </div>
          </div>
        </v-card-title>

        <v-divider />

        <!-- CONTENT -->
        <v-card-text class="px-6 py-8">
          <v-row dense>
            <!-- TITLE -->
            <v-col cols="12">
              <div class="section-label">Title</div>
              <div class="section-value">{{ detailData.eventName }}</div>
            </v-col>

            <!-- DESCRIPTION -->
            <v-col cols="12" class="mt-4">
              <div class="section-label">Description</div>
              <div class="section-value">
                {{ detailData.eventDescription }}
              </div>
            </v-col>

            <!-- TIME -->
            <v-col cols="12" class="mt-4">
              <div class="section-label">Schedule</div>
              <div class="section-value d-flex align-center">
                <v-icon size="18" class="mr-2" color="pink">
                  mdi-clock-outline
                </v-icon>
                {{ formatDate(detailData.eventDate) }} <br />
                <!-- March 15, 2026 · 8:00 AM – 4:00 PM -->
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider />

        <!-- ACTIONS -->
        <v-card-actions class="px-6 py-4">
          <v-spacer />
          <v-btn
            variant="outlined"
            color="pink"
            rounded="lg"
            @click="viewDetailDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { useDisplay } from 'vuetify';
export default {
  data() {
    return {
      portalDialog: false,
      viewDetailDialog: false,
      eventList: [],
      display: useDisplay(),
      modules: [
        {
          icon: 'mdi-account-child',
          label: 'Parents/Guardian',
          active: false,
          image: new URL('@/assets/img/parenting.jpg', import.meta.url).href,
        },
        {
          icon: 'mdi-human-male-board',
          label: 'Admin/Faculty',
          image: new URL('@/assets/img/admin_teacher.jpg', import.meta.url)
            .href,
          active: false,
        },
      ],
      features: [
        {
          icon: 'mdi-cash',
          title: 'Low down payment',
          text: 'Affordable and flexible loan options.',
        },
        {
          icon: 'mdi-clock-fast',
          title: 'Fast response',
          text: 'Get approved within minutes.',
        },
        {
          icon: 'mdi-shield-check',
          title: 'No cost of applying',
          text: 'No hidden charges or upfront fees.',
        },
      ],
      steps: [
        {
          title: 'Apply online',
          text: 'Fill out a simple online form.',
        },
        {
          title: 'Connect with lender',
          text: 'We match you with trusted lenders.',
        },
        {
          title: 'Receive payment',
          text: 'Funds are sent directly to your account.',
        },
      ],
      detailData: null,
    };
  },
  mounted() {
    this.getEventsExcepMandatory();
  },
  computed: {
    isSmAndUp() {
      return this.display.smAndUp;
    },
  },
  methods: {
    setActive(index) {
      console.log(index);
      this.modules.forEach((mod, i) => {
        mod.active = i === index;
        localStorage.setItem('userType', index);
        this.$router.push('/login');
      });
    },
    goToDiv() {
      setTimeout(() => {
        this.portalDialog = true;
      }, 50);
    },
    goToEvents() {
      document.getElementById('events').scrollIntoView({
        behavior: 'smooth',
      });
    },
    getEventsExcepMandatory() {
      // this.axiosCall('/school-events/getEventsExcepMandatory', 'GET').then(
      this.axiosCall('/school-events/getEventsWithMandatory', 'GET').then(
        (res) => {
          if (res.data) {
            let data = res.data;
            this.eventList = data;
          }
        },
      );
    },
    getIcon(type) {
      const icons = {
        Academic: 'mdi-school',
        Celebration: 'mdi-party-popper',
        Sports: 'mdi-basketball',
        Default: 'mdi-calendar',
      };
      return icons[type] || icons.Default;
    },
    Event(event) {
      console.log(event);
      this.detailData = event;
      this.viewDetailDialog = true;
    },
  },
};
</script>

<style scoped>
.hero-section {
  background: linear-gradient(135deg, #fff0f6, #ffffff);
  min-height: 90vh;
  display: flex;
  align-items: center;
}

.hero-title {
  font-size: 2.5rem;
  font-weight: 700;
}

.hero-subtitle {
  font-size: 1.1rem;
  color: #555;
}

.bg-light {
  background-color: #ffffff;
}

.event-card {
  transition: all 0.25s ease;
}

.event-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.08);
}
.portal-dialog {
  backdrop-filter: blur(6px);
}

.module-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #f2f2f2;
}

.module-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 12px 30px rgba(233, 49, 117, 0.15);
}

.inactive-card {
  background: #ffffff;
}

.active-card {
  background: linear-gradient(135deg, #e93175, #ff6fa5);
  transform: translateY(-8px) scale(1.02);
}
.school-code-light {
  font-weight: 800;
  letter-spacing: 4px;
  color: #e93175;
}
.portal-dialog {
  background: #ffffff;
}

.dialog-title {
  font-size: 1.25rem;
  font-weight: 700;
}

.dialog-subtitle {
  font-size: 0.85rem;
  color: #777;
}

.section-label {
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #999;
  margin-bottom: 4px;
}

.section-value {
  font-size: 1rem;
  color: #333;
  line-height: 1.6;
}
.event-card {
  transition: all 0.3s ease;
  border: 1px solid #f0f0f0;
}

.event-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 35px rgba(233, 49, 117, 0.15);
}
.event-image-wrapper {
  overflow: hidden;
  border-radius: 16px;
}

.event-image-wrapper img {
  transition: transform 0.4s ease;
}

.event-card:hover img {
  transform: scale(1.08);
}
</style>
